export default {
  fromValue (val) {
    switch (val) {
      case 'draft':
        return 'Rascunho'
      case 'active':
        return 'Ativa'
      case 'expired':
        return 'Expirada'
      case 'canceled':
        return 'Cancelada'
      default:
        return val
    }
  }
}
